var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", "max-width": "500" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "div",
        { staticClass: "allinea-rose" },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "warning headline" },
                [
                  !_vm.isSquadreAllineate
                    ? _c("span", { staticClass: "white--text" }, [
                        _vm._v("Disallineamento squadre"),
                      ])
                    : !_vm.isCalciatoriAllineati
                    ? _c("span", { staticClass: "white--text" }, [
                        _vm._v("Disallineamento rose"),
                      ])
                    : _c("span", { staticClass: "white--text" }, [
                        _vm._v("Riallineamento rose/crediti"),
                      ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        fab: "",
                        depressed: "",
                        outlined: "",
                        small: "",
                        color: "white",
                      },
                      on: { click: _vm.retry },
                    },
                    [_c("v-icon", [_vm._v("sync")])],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "white--text",
                      attrs: { depressed: "", icon: "" },
                      on: { click: _vm.dismiss },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "pa-4" }, [
                !_vm.isSquadreAllineate
                  ? _c(
                      "div",
                      [
                        _c(
                          "v-alert",
                          {
                            staticClass: "mt-3 mb-0",
                            attrs: { dense: "", text: "", type: "error" },
                          },
                          [
                            _vm._v(
                              "\n          C'è un disallineamento tra le squadre iscritte alla lega e quelle\n          attualmente visibili in Asta Live. "
                            ),
                            _c("strong", [_vm._v("Devi riallineare.")]),
                          ]
                        ),
                      ],
                      1
                    )
                  : !_vm.isCalciatoriAllineati
                  ? _c(
                      "div",
                      [
                        _c(
                          "v-alert",
                          {
                            staticClass: "mt-3 mb-0",
                            attrs: { dense: "", text: "", type: "default" },
                          },
                          [
                            _c("strong", [_vm._v("Dovresti riallineare")]),
                            _vm._v(" le rose/crediti."),
                            _c("br"),
                            _c("br"),
                            _vm._v(
                              "\n\n          Rose e crediti che vedi su Asta Live sono diversi da quelli "
                            ),
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.roseLegaUrl,
                                  target: "_blank",
                                },
                              },
                              [_vm._v("che adesso vedi su app/sito")]
                            ),
                            _vm._v(". "),
                            _c("br"),
                            _vm._v(
                              "\n          È una cosa del tutto normale: succede se avete fatto dei movimenti di mercato (o modificato manualmente i crediti) al di\n          fuori di Asta Live (es: tramite Assegna/Svincola manuale, AstaEbay ecc.). Prima di procedere a utilizzare Asta Live dovresti riallineare (ovvero sovrascrivere) le rose di Asta Live in modo che tutto sia di nuovo uguale ad app/sito e sia il punto di partenza per avviare l'asta ;)\n\n          "
                            ),
                            _c("br"),
                            _c("br"),
                            _vm._v(
                              "\n          Cosa succede se non riallinei?\n\n          "
                            ),
                            _c("br"),
                            _vm._v(
                              'Asta Live potrebbe assegnare un calciatore che su sito/app non era tra gli svincolati ma era già in una rosa.\n          Quindi, quando alla fine dell\'asta in Asta Live andrai a "Salvare Assegnazioni/Rose", il sistema ti darà errore perché un calciatore risulterà non assegnabile in quanto non svincolato.\n\n           '
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-alert",
                          {
                            staticClass: "mt-3 mb-0",
                            attrs: { dense: "", text: "", type: "info" },
                          },
                          [
                            _vm._v(
                              "\n            Se non hai ancora mai usato Asta Live, puoi riallineare senza problemi.\n            Se invece avevi già avviato Asta Live e ci sono assegnazioni NON ANCORA SALVATE definitivamente su app/sito,\n            "
                            ),
                            _c("strong", [
                              _vm._v(
                                "assicurati di segnarti quelle assegnazioni a mano o andranno perse"
                              ),
                            ]),
                            _vm._v(" quando riallinerai.\n          "),
                          ]
                        ),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      [
                        _vm._v(
                          "\n          Asta Live ci sembra già allineata con rose/crediti\n          "
                        ),
                        _c(
                          "a",
                          {
                            attrs: { href: _vm.roseLegaUrl, target: "_blank" },
                          },
                          [_vm._v("che adesso vedi sul sito/app")]
                        ),
                        _vm._v(
                          ".\n          Volendo potresti comunque forzare un riallineamento."
                        ),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "v-alert",
                          {
                            staticClass: "mt-3 mb-0",
                            attrs: { dense: "", text: "", type: "info" },
                          },
                          [
                            _vm._v(
                              "\n            Se non hai ancora mai usato Asta Live, puoi riallineare senza problemi.\n            Se invece avevi già avviato Asta Live e ci sono assegnazioni NON ANCORA SALVATE definitivamente su app/sito,\n            "
                            ),
                            _c("strong", [
                              _vm._v(
                                "assicurati di segnarti quelle assegnazioni a mano o andranno perse"
                              ),
                            ]),
                            _vm._v(" quando riallinerai.\n          "),
                          ]
                        ),
                      ],
                      1
                    ),
                _vm._v(" "),
                !_vm.isCalciatoriAllineati
                  ? _c("div", { staticClass: "table-comparisons" }, [
                      _c(
                        "table",
                        { class: { "nice-scroll": !_vm.is_mobile } },
                        [
                          _c("thead", [
                            _c("tr", [
                              _c("th"),
                              _vm._v(" "),
                              _c("th", [_vm._v("Asta Live")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("App/Sito")]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            _vm._l(
                              _vm.comparisons,
                              function (obj, id_calciatore) {
                                return _c("tr", { key: id_calciatore }, [
                                  _c("td", [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.calciatori[id_calciatore]
                                            .calciatore
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex justify-left align-center",
                                      },
                                      [
                                        obj.pre
                                          ? _c("div", [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.asta_squadre[
                                                      obj.pre.squadra_id
                                                    ].name
                                                  ) +
                                                  " (" +
                                                  _vm._s(obj.pre.p) +
                                                  ")\n                    "
                                              ),
                                            ])
                                          : _c("div", [_vm._v("Svincolato")]),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex justify-left align-center",
                                      },
                                      [
                                        obj.post
                                          ? _c("div", [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.asta_squadre[
                                                      obj.post.squadra_id
                                                    ].name
                                                  ) +
                                                  " (" +
                                                  _vm._s(obj.post.p) +
                                                  ")\n                    "
                                              ),
                                            ])
                                          : _c("div", [_vm._v("Svincolato")]),
                                      ]
                                    ),
                                  ]),
                                ])
                              }
                            ),
                            0
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex justify-center align-center" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "ma-2",
                      attrs: { rounded: "", depressed: "", color: "warning" },
                      on: { click: _vm.allineaRose },
                    },
                    [_vm._v("\n          Riallinea\n        ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }